/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API45662Req {
  
  /** 身份唯一码 */
  thirdCode?: string;
  /** 第三方平台信息 */
  thirdPlatform?: string;
  /** 平台编码，详见数据库business_platform数据 */
  platformCode?: string;
  /** 灰度平台 */
  grayPlatform?: string;
};



export interface API45662Res {
  /** 三方平台id  */
  thirdId?: string;
  /** 扩展属性 ,Object  */
  extendParams?: any;
  /** 是否和内部账号进行过关联  */
  isBind?: boolean;
  /** 用户id  */
  userId?: string;
  /** 业务id  */
  userName?: string;
  /** 真实姓名  */
  realName?: string;
  /** 用户头像地址  */
  headIcon?: string;
  /** 注册手机号  */
  userPhone?: string;
  /** 用户登录token  */
  userToken?: string;
  /** 是否灰度用户  */
  isGray?: boolean;
  /** 灰度配置参数  */
  grayParams?: string;
  /** 是否需要重置密码  */
  needReset?: boolean;
  
};


// 45662 扫码登录

export interface IUsePostAPI45662Return {
  /** 扫码登录: 接口请求状态 */
  isAPI45662Loading: boolean;
  /** 扫码登录: 接口请求返回数据 */
  dataAPI45662: API45662Res;
  /**  扫码登录: 接口数据请求方法 */
  fetchAPI45662Data:  (inputs: API45662Req, config?: YWRequestConfig) => Promise<API45662Res>;
  /** 扫码登录: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI45662 = ():IUsePostAPI45662Return => {
  let isMount = true;
  const [isAPI45662Loading, setIsAPI45662Loading] = useState(false);
  const [dataAPI45662, setDataAPI45662] = useState<API45662Res>({} as API45662Res);
  const requestUrl = `${basePath}/ywwl-admin/business/user/scan/login`;

  const fetchAPI45662Data = async (inputs: API45662Req, config?: YWRequestConfig): Promise<API45662Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API45662Req>) || {}) as API45662Req;
    
  
    if ( isMount ) {
      setIsAPI45662Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API45662Res>(`${basePath}/ywwl-admin/business/user/scan/login`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI45662(res || {} as API45662Res);
        setIsAPI45662Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI45662Loading(false);
      }
      return false as unknown as API45662Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI45662Loading,
    dataAPI45662,
    fetchAPI45662Data,
    requestUrl,
  }
}

